import React from 'react';
import OverflowTooltip from '../utils/OverflowTooltip';
import ArrowIconToggle from '../utils/icon/ArrowIconToggle';
import GenericTooltip from 'components/pure/tooltips/GenericTooltip';
import {TOOLTIP_DELAY} from 'components/StatsPage2.utils';

export default class SortableTableHeader extends React.PureComponent {
  getSortIndicator(renderColumn, sortDirection, sortColumn) {
    if (renderColumn !== sortColumn) {
      return null;
    }
    return sortDirection;
  }

  render() {
    const {
      label,
      sortDirection,
      renderColumn,
      sortColumn,
      onClick,
      tooltipEnabled = true,
      popoverMessage,
      popoverClassName,
      sortingDisabled = false,
    } = this.props;

    const labelElement = <div className="header-text-overflow">{label}</div>;

    return (
      <GenericTooltip
        positionTop
        delay={TOOLTIP_DELAY}
        tooltip={popoverMessage}
        className={popoverClassName}>
        <div
          className={`header-wrapper ${sortingDisabled ? 'no-sort' : ''}`}
          onClick={e => !sortingDisabled && onClick(e)}>
          <div className="header-text">
            {tooltipEnabled ? (
              <OverflowTooltip tooltipText={label} divKey={'item-' + label}>
                {labelElement}
              </OverflowTooltip>
            ) : (
              labelElement
            )}
          </div>
          <ArrowIconToggle
            sortDirection={this.getSortIndicator(renderColumn, sortDirection, sortColumn)}
          />
        </div>
      </GenericTooltip>
    );
  }
}
